import type { UserBaseInfoType } from "@/views/types";
import JSBridge from "@h5-monorepo/shared/bridge";
import { getStorage, setStorage } from '@h5-monorepo/shared/utils/storage';
import { eventBus, LOGIN_EVENTS } from "@h5-monorepo/shared/utils/eventBus";
import { defineStore } from "pinia";

interface State {
  loading: boolean;
  statusHeight: number;
  token: string;
  tempToken: string;
  userInfo?: UserBaseInfoType | null;
}
export const useStore = defineStore('store', {
	state: (): State => {
		return {
			loading: false,
			statusHeight: 0,
			token: '',
			tempToken: '',
			userInfo: null
		};
	},
	actions: {
		setToken(token?: string) {
			let tokenStr = getStorage('docoiToken');
			let tokenObj = tokenStr ? JSON.parse(tokenStr) : {};
			tokenObj.token = token || '';
			setStorage('docoiToken', JSON.stringify(tokenObj));
		},
		isLogin(toLogin?: boolean) {
			let tokenStr = getStorage('docoiToken');
			let tokenObj = tokenStr ? JSON.parse(tokenStr) : {};
			if (toLogin && !tokenObj?.token) {
				JSBridge.call('login');
			}
			return !!tokenObj?.token;
		},
		setTempToken(tempToken?: string) {
			if (this.tempToken !== tempToken) {
				this.tempToken = tempToken || '';
			}
		},
		setUserInfo(userInfo: UserBaseInfoType) {
			delete userInfo.token;
			this.userInfo = { ...userInfo, id: userInfo.id || userInfo.uid };
		},

		// 新增：初始化登录事件订阅
		initLoginEventSubscription() {
			// 订阅登录成功事件
			eventBus.on(LOGIN_EVENTS.LOGIN_SUCCESS, ({ token, userInfo }) => {
				if (token) {
					this.setToken(token);
				}
				if (userInfo) {
					this.setUserInfo(userInfo);
				}
			});

			// 订阅登出事件
			eventBus.on(LOGIN_EVENTS.LOGOUT, () => {
				this.setToken('');
				this.setUserInfo({} as UserBaseInfoType);
			});
		}
	},
	persist: {
		storage: localStorage
	}
});
